import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/** /ara → /notlar yönlendirmesi (geriye uyum) */
const SearchPage: React.FC = () => {
  const [params] = useSearchParams();
  const q = params.get('q');
  const next = new URLSearchParams();
  if (q) next.set('q', q);
  const qs = next.toString();
  return <Navigate to={qs ? `/notlar?${qs}` : '/notlar'} replace />;
};

export default SearchPage;
